import { render, staticRenderFns } from "./ListDocumentationPage.vue?vue&type=template&id=4fe35099"
import script from "./ListDocumentationPage.vue?vue&type=script&lang=js"
export * from "./ListDocumentationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports